import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import Constants from '../utils/constants'

const AdminRoute = ({ children }) => {
  const navigate = useNavigate()
  const { user, loading } = useSelector((state) => state.user)

  useEffect(() => {
    if (loading) return

    if (user?.role !== Constants.ROLES.ADMIN) {
      navigate('/orders/new')
    }
  }, [user, loading, navigate])

  if (loading) {
    return null
  }

  if (user?.role !== Constants.ROLES.ADMIN) {
    return null
  }

  return children
}

export default AdminRoute